import React from 'react';
import classnames from 'classnames';

import less from './tooltip-content.less';
import { emptyObject } from '../../../default-props/empty';
import { noop } from '../../../default-props/noop';
import { TOOL_TIP_POSITIONS } from '../../../services/tooltip-service';

/**
 * @typedef {import('./tooltip-content-types.d.ts').TooltipArrowClassValues} TooltipArrowClassValues
 */

/**
 * @typedef {import('./tooltip-content-types.d.ts').TooltipContentComponent} TooltipContentComponent
 */

/** @type {Record<string, TooltipArrowClassValues>} */
export const ARROW_CLASS_VALUES = {
  down: 'down',
  right: 'right',
  left: 'left',
  up: 'up',
};

/**
 * @type {TooltipContentComponent}
 */
export const TooltipContent = React.forwardRef(
  (
    {
      children,
      onMouseLeave = noop,
      style = emptyObject,
      arrowClass = ARROW_CLASS_VALUES.down,
      position = TOOL_TIP_POSITIONS.top,
      lightTheme = false,
      isClickable = false,
      contentClassName = '',
    },
    ref,
  ) => {
    return (
      <div
        ref={ref}
        className={classnames(less.tooltip, less[position], {
          [less['light-tooltip']]: lightTheme,
          [less['clickable-tooltip']]: isClickable,
        })}
        onMouseLeave={onMouseLeave}
        style={style}
      >
        <div className={classnames(less['tooltip-content'], contentClassName)}>
          {children}
          <div className={classnames(less['tooltip-arrow'], less[arrowClass])} />
        </div>
      </div>
    );
  },
);
